module.exports = __webpack_public_path__ + "img/import-csv-material.19197937.svg";